import { multiUserApi } from "../../../../shared/utils/multiUserFunctions";
import { appAiScoringApi } from "../../config/apiConfig";
import {
  TAiCaseExamplesResponse,
  TAiScoringRequest,
  TAiScoringResponse,
  TAiScoringTip,
  TAiTipRequest,
  TCaseGenerateSolutionPromptResponse,
} from "./types";

export const postAiScoringCase = (
  postObj: TAiScoringRequest,
  signal?: AbortSignal,
): Promise<TAiScoringResponse> => {
  return appAiScoringApi
    .post("/api/cases/validate", postObj, {
      withCredentials: false,
      signal: signal,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getAiTip = (postObj: TAiTipRequest): Promise<TAiScoringTip> => {
  return appAiScoringApi
    .post("/api/cases/suggest-field", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const getAiCaseExamples = (
  postObj: TAiScoringRequest,
): Promise<TAiCaseExamplesResponse> => {
  return appAiScoringApi
    .post("/api/cases/search-examples", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};

export const generateCaseSolutionPrompt = (
  postObj: TAiScoringRequest,
): Promise<TCaseGenerateSolutionPromptResponse> => {
  return appAiScoringApi
    .post("/api/cases/generate-solution-prompt", postObj, {
      withCredentials: false,
      headers: {
        "X-Keycloak-Token": multiUserApi.getUserKey("access_token"),
      },
    })
    .then((res) => res.data);
};
